import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TbRefresh } from 'react-icons/tb'
import {
  getThemeFromStorage,
  DEFAULT_THEME,
  getThemeMode,
  updateDocumentBodyByTheme,
} from '@/ui-components/utils/theme-utils'
import { ThemeMode } from '@/ui-components/constants/theme'
import errorDarkSvg from '@/images/error_svg/error_dark.svg?url'
import errorLightSvg from '@/images/error_svg/error_light.svg?url'

const ErrorPage = ({
  resetError,
}: {
  error?: unknown
  componentStack?: string
  resetError?: () => void
}) => {
  const { t } = useTranslation()
  const savedTheme = useMemo(() => getThemeFromStorage() || DEFAULT_THEME, [])

  useEffect(() => {
    updateDocumentBodyByTheme(savedTheme)
  }, [savedTheme])

  const themeMode = getThemeMode(savedTheme)
  const errorImage = themeMode === ThemeMode.DARK ? errorDarkSvg : errorLightSvg

  return (
    <div className="min-h-screen bg-[var(--bg-theme)] flex flex-col items-center justify-center px-4 py-8">
      <div className="max-w-md w-full text-center md:min-w-[520px]">
        {/* Error SVG Icon */}
        <div className="mb-4">
          <img
            src={errorImage}
            alt="Error occurred"
            className="w-full h-auto max-w-sm mx-auto"
          />
        </div>

        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[var(--card-title)] mb-4">
            {t('error.errorPageTitle')}
          </h1>
          <p className="text-lg text-[var(--card-subtext)] mb-6">
            {t('error.errorPageDescription')}
          </p>
          {/* <p className="text-lg text-[var(--card-subtext)] mb-6">
            {error instanceof Error ? error.toString() : String(error)}
          </p> */}
          {/* {componentStack && (
            <pre className="text-sm text-[var(--card-subtext)] mb-6 whitespace-pre-wrap">
              {componentStack}
            </pre>
          )} */}
        </div>
        <button
          onClick={resetError}
          className="w-full md:w-auto px-8 py-3 font-semibold rounded-lg active-gradient"
        >
          <TbRefresh className="inline-block mr-2 text-xl" />
          {t('error.reloadPage')}
        </button>
      </div>
    </div>
  )
}

export default ErrorPage
